export default {
  // sys admin - user list header
  'users.title': 'Users',
  'users.createUserBtn': 'Create user',

  // users table column headers
  'users.tableHeader.name': 'Name',
  'users.tableHeader.status': 'Status',
  'users.tableHeader.email': 'Email',
  'users.tableHeader.role': 'Role(s)',
  'users.tableHeader.organization': 'Organization',
  'users.tableHeader.lastLogin': 'Last login',

  // action menu items
  'users.tableHeader.actionMenu.editUser': 'Edit users',
  'users.tableHeader.actionMenu.resetPassword': 'Reset password',

  // create / edit user dialog
  'users.createEditDialog.createTitle': 'Create user',
  'users.createEditDialog.editTitle': 'Edit user details',
  'users.createEditDialog.createDescription':
    'All fields are required unless they’re marked optional.',

  // workflow messages
  'users.createEditDialog.saveCreateBtnLabel': 'Create user',
  'users.createEditDialog.saveEditBtnLabel': 'Save changes',
  'users.createEditDialog.savingEditBtnLabel': 'Saving changes',
  'users.createEditDialog.successCreateTextCreate': 'User was created successfully.',
  'users.createEditDialog.successEditTextCreate': 'User was updated successfully.',
  'users.createEditDialog.errorTextEdit':
    'User could not be updated due to a system error. You can retry creating the user by selecting the action below.',
  'users.createEditDialog.errorTextUserExists':
    'Email with this name already exists, please enter a unique name.',
  'users.createEditDialog.submittingSaveBtnText': 'Create user',
  'users.createEditDialog.submittingErrorSaveBtnText': 'Retry',
  'users.createEditDialog.submittingErrorCancelBtnText': 'Cancel',

  // sections
  'users.createEditDialog.section.userDetails': 'User details',
  'users.createEditDialog.section.organization': 'Organization',
  'users.createEditDialog.section.userRoles': 'User role(s)',

  'users.createEditDialog.firstNameLabel': 'First name',
  'users.createEditDialog.firstNamePlaceholder': 'Enter first name',
  'users.createEditDialog.firstNameMaxLength': 'First name max length is 60 characters',
  'users.createEditDialog.lastNameLabel': 'Last name',
  'users.createEditDialog.lastNamePlaceholder': 'Enter last name',
  'users.createEditDialog.lastNameMaxLength': 'Last name max length is 60 characters',
  'users.createEditDialog.emailLabel': 'Email',
  'users.createEditDialog.emailPlaceholder': 'Enter email',
  'users.createEditDialog.emailInvalidMessage': 'Please enter a valid email address',
  'users.createEditDialog.organizationLabel': 'Organization',
  'users.createEditDialog.organizationPlaceholder': 'Select organization',
  'users.createEditDialog.rolesEmpty':
    'Roles will become available after an organization has been selected.',
  'users.createEditDialog.role.AnnotionSupervisor': 'Annotation supervisor',
  'users.createEditDialog.role.Annotator': 'Annotator',
  'users.createEditDialog.role.DataAdmin': 'Data administrator',
  'users.createEditDialog.role.ResearchPartner': 'Research partner',
  'users.createEditDialog.role.Researcher': 'Researcher',
  'users.createEditDialog.role.StudyAdmin': 'Study administrator',
  'users.createEditDialog.role.SysAdmin': 'System administrator',
  'users.createEditDialog.role.rolesReseachPartnerNotSupported':
    'Research partner organization is not supported at this time',

  // reest password dialog
  'users.resetPasswordDialog.title': 'Confirm reset',
  'users.resetPasswordDialog.text':
    'Resetting the password will send an email to {emailAddress} with instructions on how to reset the password.',
  'users.resetPasswordDialog.saveBtnText': 'Reset password',
  'users.resetPasswordDialog.successText': 'Reset password email has been sent successfully.',

  // user info/details dialog
  'users.userInfoDialog.dialogHeader': 'User details',
  'users.userInfoDialog.title': 'User details',
  'users.userInfoDialog.logHeader': 'Log details',
  'users.userInfoDialog.fullName': 'Full name',
  'users.userInfoDialog.status': 'Status',
  'users.userInfoDialog.emailAddress': 'Email address',
  'users.userInfoDialog.roles': 'Roles',
  'users.userInfoDialog.organization': 'Organization',
  'users.userInfoDialog.lastLogin': 'Last login',
  'users.userInfoDialog.createdBy': 'Created by',
  'users.userInfoDialog.createdOn': 'Created on',
  'users.userInfoDialog.modifiedBy': 'Last modified by',
  'users.userInfoDialog.modifiedOn': 'Last modified on',
};
